import { Testable } from '@eventops/chronotrack-ctlive-mui'
import { createLogger } from '../../app/logger'
import useAppSelector from '../../hooks/useAppSelector'
import { getTokenSelector, getUsernameSelector } from '../../features/session/sessionSlice'
import AccessPage from '../../pages/AccessPage'
import CheckinPage from '../../pages/CheckinPage'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'AccessRouter',
})

export type AccessRouterProps = {} & Testable

const AccessRouter = (props: AccessRouterProps) => {
  const username = useAppSelector(getUsernameSelector)
  const token = useAppSelector(getTokenSelector)
  return username && token ? <CheckinPage {...props} /> : <AccessPage {...props} />
}

export default AccessRouter
